// extracted by mini-css-extract-plugin
export default {"appLayout":"App_appLayout__MVuzl","sidebar":"App_sidebar__LZ1kk","mainContent":"App_mainContent__F1UzS","header":"App_header__6UTxg","dashboard":"App_dashboard__ea0YO"};